import { render, staticRenderFns } from "./CapeTown.vue?vue&type=template&id=1ce02af8&"
import script from "./CapeTown.vue?vue&type=script&lang=js&"
export * from "./CapeTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports